import React, { useState, useEffect, useRef } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import { Alert, Button } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast, ToastContainer } from "react-toastify";
import cloneDeep from 'lodash/cloneDeep';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import FormHandler from "../Common/Form/FormHandler/FormHandler";
import { createevent, createincidentsitu, createMasterResource, findAllChildrenRegionsById, getconfigdatacate, getgpdetails, getincidentcatcreate, getincidentDatain, getincidentFilteredDatain, getMasterResourceByIdURL, getpanchaycentersa, getstatusdetails, getThemeURL, resourceActivityListURL, resourceCatListURL, saveimageevent, updateincident } from "../../../Services/EndPoints";
import { setRegFilesToStore } from "../../../CentralStore/RegistrationsSlice/registrationSlice";
import { IncidentResourceConfig, incidentresourceschema } from "../../../JsonData/IncidentResourceConfig";
import Tree from "rc-tree";
import RegionNode from "../RegionManagement/RegionList/RegionTree/RegionNode";
import RMMap from "../RegionManagement/RMMap/RMMap";
import { getData, postDataWithBody, postDataWithBodyEvent } from "../../../Services/Services";
import IncidentMap from "../RegionManagement/RMMap/IncidentMap";
import IncidentTable from "../GisincidentManagement/IncidentTable";
import { ClockFading } from "lucide-react";
import { EventResourceConfig, eventresourceschema } from "../../../JsonData/EventResourceConfig";
import EventMap from "../RegionManagement/RMMap/EventMap";

const CreateEventFormPage = () => {
    const [masterresourceConfig, setMasterResourceConfig] = useState(EventResourceConfig);
    const [resourceCategoriesList, setResourceCategoriesList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [masterCategory, setMasterCategory] = useState(null);
    const [status, setStatus] = useState("");
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(0);
    const [clickedPoint, setClickedPoint] = useState(null);
    const { t } = useTranslation();
    const { state } = useLocation();
    const dispatch = useDispatch();
    let id = state?.id;
    let edit = state?.edit;
    let imgName = state?.imgName;
    let byteArray;
    // State for file upload
    const [selectedFile, setSelectedFile] = useState(null);
    const [filePreview, setFilePreview] = useState(null);

    const {
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        trigger,
        reset,
        control,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(eventresourceschema[activeTab]),
        mode: "all",
    });

    const [showPopup, setShowPopup] = useState(false);
    const [districtId, setDistrictId] = useState("");
    const [selectedDistrictIds, setSelectedDistrictIds] = useState([]);
    const [selectedRegions, setSelectedRegions] = useState([]);
    const [selectedBlockIds, setSelectedBlockIds] = useState([]);
    const [selectedPanchayatIds, setSelectedPanchayatIds] = useState([]);
    const [selectedVillageIds, setSelectedVillageIds] = useState([]);
    const [treeData, setTreeData] = useState([]);
    const [regionTypeId, setRegionTypeId] = useState(null);
    const [actionType, setActionType] = useState("");
    const [keyVal, setKeyVal] = useState("");
    const [actionTypeHeader, setActionTypeHeader] = useState("");
    const [id1, setId] = useState(null);
    const [checkedKeys, setCheckedKeys] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const regionDataMap = useRef(new Map()).current;
    const [selectedPanchayat, setSelectedPanchayat] = useState([]);
    const [statusarray, setstatusarray] = useState([])
    const [searchValue, setSearchValue] = useState('');
    const [panchaycent, setpanchaycent] = useState([])
    const [coordinates, setCoordinates] = useState({
        latitude: null,
        longitude: null
    });
    const [username, setusername] = useState("")
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [filePreviews, setFilePreviews] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const handleShow = () => setShowPopup(true);
    const handleClose = () => setShowPopup(false);

    const currentIncidentId = watch("incidentname");
    console.log("currnennn", currentIncidentId)

    useEffect(() => {
        getregiondetails(currentIncidentId)
    }, [currentIncidentId])
    const getregiondetails = async (id) => {
        try {
            const ince_region = await postDataWithBody(updateincident, [id], {})
            console.log("inceregion", ince_region)
            setSelectedPanchayatIds([]);
            if (ince_region?.regions?.length > 0) {
                const panchayatIds = ince_region.regions
                    .map(region => region.gis_id)
                    .filter(gis_id => gis_id !== null);

                setSelectedPanchayatIds(panchayatIds);


            }


        } catch (error) {
            setSelectedPanchayatIds([]);
        }

    }

    const handleLocationSelect = (coords) => {
        setCoordinates(coords);
        // Update form values
        setValue("latitude", coords.latitude);
        setValue("longitude", coords.longitude);
    }

    // File upload handler
    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);

        // Filter only image and video files
        const mediaFiles = files.filter(file =>
            file.type.startsWith('image/') || file.type.startsWith('video/')
        );

        if (mediaFiles.length > 0) {
            setSelectedFiles(mediaFiles);

            // Create previews for media files
            const previews = [];
            mediaFiles.forEach(file => {
                const reader = new FileReader();
                reader.onload = (event) => {
                    previews.push({
                        url: event.target.result,
                        type: file.type.startsWith('image/') ? 'image' : 'video'
                    });
                    if (previews.length === mediaFiles.length) {
                        setFilePreviews(previews);
                    }
                };
                reader.readAsDataURL(file);
            });
        }
    };


    // Function to convert file to byte array
    const filesToByteArrays = async (files) => {
        const byteArrays = [];
        for (const file of files) {
            const byteArray = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (event) => {
                    const arrayBuffer = event.target.result;
                    const byteArray = new Uint8Array(arrayBuffer);
                    resolve(Array.from(byteArray));
                };
                reader.onerror = (error) => reject(error);
                reader.readAsArrayBuffer(file);
            });
            byteArrays.push({
                name: file.name,
                type: file.type,
                data: byteArray
            });
        }
        return byteArrays;
    };

    useEffect(() => {
        getUserdataprof();
    }, []);

    const getUserdataprof = async () => {
        try {
            const usr_prof = await getData(getThemeURL);
            setusername(usr_prof[0].user_name);
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };

    useEffect(() => {
        if (imgName) {
            setValue("resource_image_name", imgName);
        }
    }, [imgName, setValue]);

    const rscractivity = useWatch({
        control,
        name: "activity",
    });

    useEffect(() => {
        getInitFormData();
    }, [t]);

    useEffect(() => {
        const rscractivity = getValues("activity");
        if (rscractivity && rscractivity != "") {
            getCategoryByActivity(rscractivity);
        }
    }, [rscractivity]);

    const getInitFormData = async () => {
        setLoader(true);
        await getActivityList();
        setLoader(false);
    };


    const getActivityList = async () => {
        try {
            const incidentData = await getData(getincidentFilteredDatain);
            const incidentList = Array.isArray(incidentData) ? incidentData : [];
            const options = incidentList.map(item => ({
                value: item.id || item.value || '',
                label: item.name || item.label || 'Unnamed Incident'
            }));

            const updatedConfig = cloneDeep(EventResourceConfig);
            updatedConfig[0].fields[0].options = [
                { label: t('masterresourceplaceholder.select'), value: "" },
                ...options
            ];

            setMasterResourceConfig(updatedConfig);
        } catch (error) {
            console.error("Error fetching incident data:", error);
            const updatedConfig = cloneDeep(EventResourceConfig);
            updatedConfig[0].fields[0].options = [
                { label: t('masterresourceplaceholder.select'), value: "" }
            ];
            setMasterResourceConfig(updatedConfig);
        }
    };

    const getCategoryByActivity = async (activity) => {
        if (activity != "") {
            var resourceCategoryList = await getData(resourceCatListURL + activity);
            for (let resourceCat in resourceCategoryList) {
                resourceCategoryList[resourceCat]["label"] =
                    resourceCategoryList[resourceCat]["category"];
                resourceCategoryList[resourceCat]["value"] =
                    resourceCategoryList[resourceCat]["category"];
            }
            masterresourceConfig[0].fields[1]["options"] = [
                { label: t('masterresourceplaceholder.select'), value: "" },
            ].concat(resourceCategoryList);
        } else {
            masterresourceConfig[0].fields[1]["options"] = [
                { label: t('masterresourceplaceholder.select'), value: "" },
            ];
            setMasterResourceConfig(masterresourceConfig);
        }
        setMasterResourceConfig(masterresourceConfig);
        setResourceCategoriesList(resourceCategoryList);
        if (id) {
            await getMasterResourceList();
        }
    };

    async function getMasterResourceList() {
        let masterResourceList = await postDataWithBody(
            getMasterResourceByIdURL,
            [id],
            {}
        );
        console.log("masterResourceList:", masterResourceList);
        masterResourceList = masterResourceList[0];
        reset(masterResourceList);
        setMasterCategory(masterResourceList.category);
    }

    const GenerateForm = (fields, register, errors, control) => {
        return (
            <div>
                <FormHandler
                    register={register}
                    errors={errors}
                    fields={fields}
                    control={control}
                    setValue={setValue}
                    columns={2}
                    getValues={getValues}
                    imgName={imgName}
                    handleShow={handleShow}
                    handleFileChange={handleFileChange} // Pass file change handler
                    filePreviews={filePreviews}
                    multiple// Pass file preview
                    uploadfilewidth={true}
                />
            </div>
        );
    };

    const generateTabsData = (tabWiseData) => {
        tabWiseData?.forEach((element) => {
            return (element.component = GenerateForm(
                element?.fields,
                register,
                errors,
                control
            ));
        });
        return tabWiseData;
    };

    const submitHandler = async (data, e) => {
        e.preventDefault();
        setLoader(true);
        setIsSubmitting(true);
        console.log("event data", data);
        console.log("Current selectedFiles:", selectedFiles);

        // Format date
        const dateObj = new Date(data.eventdatetime);
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');
        let hours = dateObj.getHours();
        const minutes = String(dateObj.getMinutes()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        const paddedHours = String(hours).padStart(2, '0');
        const formatted = `${year}/${month}/${day} ${paddedHours}:${minutes} ${ampm}`;

        try {
            // Prepare FormData
            const formData = new FormData();
            formData.append("createdBy", username);
            formData.append("incidentId", parseInt(data.incidentname));
            formData.append("lat", data.latitude);
            formData.append("lng", data.longitude);
            formData.append("time", formatted);
            formData.append("action", data.eventDes);
            formData.append("status", "OPEN");

            if (selectedFiles.length > 0) {
                selectedFiles.forEach(file => {
                    formData.append("files", file);
                });
            }

            // Use postDataWithBody with FormData (no headers override)
            const res = await postDataWithBodyEvent(createevent, formData);

            if (res.message === "Event Created Successfully") {
                toast.success(res.message, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                });

                navigate("/situation-awareness/incident-management");
                dispatch(setRegFilesToStore({ type: "reset" }));
            } else {
                toast.error(res.message || "Failed to create event", {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                });
                setIsSubmitting(false);
            }
        } catch (error) {
            console.error("Submission error:", error);
            toast.error("An error occurred during submission", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
            });
            setIsSubmitting(false);
        } finally {
            setLoader(false);
            setIsSubmitting(false);
        }
    };


    const tabsData = generateTabsData(masterresourceConfig);

    return (
        <>
            <EventMap
                selectedRegions={selectedRegions}
                selectedDistrictIds={selectedDistrictIds}
                selectedBlockIds={selectedBlockIds}
                selectedPanchayatIds={selectedPanchayatIds}
                selectedVillageIds={selectedVillageIds}
                selectedDistrictId={districtId}
                isLoading={isLoading}
                onLocationSelect={handleLocationSelect}
                clickedPoint={clickedPoint}
                setClickedPoint={setClickedPoint}
            />
            <div className="mt-4">
                <div className="form-body">
                    <div className="registration__form--body" style={{}}>
                        <form
                            onSubmit={handleSubmit(submitHandler)}
                            name="MasterResourceRegForm"
                            encType="multipart/form-data"
                        >
                            <div>
                                {tabsData?.map((tab) => (
                                    <>
                                        {tab.id === activeTab && (
                                            <>
                                                <div className="registration__form--heading">
                                                    {tab.heading}
                                                </div>
                                                <div>{tab.component}</div>
                                            </>
                                        )}
                                    </>
                                ))}
                            </div>

                            <div className="d-flex justify-content-center">
                                {tabsData.length - 1 === activeTab && (
                                    <Button type="submit" className="mx-2" variant="primary" style={{ marginBottom: '8px' }} disabled={isSubmitting || loader}>
                                        {edit ? "Update" : t('Save & Submit')}
                                    </Button>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreateEventFormPage;